<div class="detail-view-container">
    <ng-content />
</div>
